import httpClient from './httpClient';

export const PROFILE_API = '/backoffice/me';

export const getProfileAPI = () => httpClient.get(PROFILE_API);
export const updateProfileAPI = (params) => httpClient.put(PROFILE_API, params);
